import axios from 'axios';

/**
 * R2-4: the answers the backend gives before it writes anything (validation,
 * authorization, not found, conflict, domain refusal). Only these, or a
 * success, end a submit series.
 */
export const DEFINITIVE_REFUSAL_STATUSES: ReadonlySet<number> = new Set([
  400, 403, 404, 409, 422,
]);

/**
 * F-8: the backend checks activation before it replays a stored key, so a
 * retry of a committed write answers 422 WAREHOUSE_DISABLED while the
 * Warehouse is off. Dropping the key there could post twice after re-enable.
 */
function isWarehouseDisabled(data: unknown): boolean {
  return (
    typeof data === 'object' &&
    data !== null &&
    (data as { code?: unknown }).code === 'WAREHOUSE_DISABLED'
  );
}

/**
 * Keeping a key is always safe; losing one after a committed write lets the
 * next click post twice. So every outcome that is not a success or a
 * definitive refusal keeps it: no response, 408, 429, every 5xx (a gateway
 * 502/504 can hide a committed write), any other status, non-HTTP errors and
 * 422 WAREHOUSE_DISABLED (F-8).
 */
export function shouldKeepOperationKey(error: unknown): boolean {
  if (error === undefined) {
    return false;
  }
  if (!axios.isAxiosError(error) || !error.response) {
    return true;
  }
  const { status, data } = error.response;
  if (status === 422 && isWarehouseDisabled(data)) {
    return true;
  }
  return !DEFINITIVE_REFUSAL_STATUSES.has(status);
}
